import React from "react";
import { useTranslation } from "react-i18next";
import { BaseControlQuestionProps } from "./type";
import { MultipleSelectBoxQuestion as MultipleSelectBoxType } from "@shared/types";
import { Question } from "../question";
import { SelectInputBoxOption } from "component-library";
import { ControlledSelectInputBox } from "../form/controlled-select-input-box";

export const MultipleSelectBoxQuestion: React.FC<
  BaseControlQuestionProps & Omit<MultipleSelectBoxType, "type" | "required">
> = ({ position, id, control, question, answer_options, required }) => {
  const { i18n } = useTranslation();

  return (
    <Question
      id={id}
      question={<span>{question[i18n.language]}</span>}
      position={position}
      direction="column"
    >
      <ControlledSelectInputBox
        name={id}
        control={control}
        isMultiSelect={true}
        required={required}
      >
        {Object.values(answer_options).map(({ value, label }) => (
          <SelectInputBoxOption key={value} value={value}>
            {label[i18n.language]}
          </SelectInputBoxOption>
        ))}
      </ControlledSelectInputBox>
    </Question>
  );
};
